/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FastPlayGameResponse } from './FastPlayGameResponse';
import {
    FastPlayGameResponseFromJSON,
    FastPlayGameResponseFromJSONTyped,
    FastPlayGameResponseToJSON,
} from './FastPlayGameResponse';
import type { InstantGame } from './InstantGame';
import {
    InstantGameFromJSON,
    InstantGameFromJSONTyped,
    InstantGameToJSON,
} from './InstantGame';
import type { RapidGame } from './RapidGame';
import {
    RapidGameFromJSON,
    RapidGameFromJSONTyped,
    RapidGameToJSON,
} from './RapidGame';
import type { DrawGame } from './DrawGame';
import {
    DrawGameFromJSON,
    DrawGameFromJSONTyped,
    DrawGameToJSON,
} from './DrawGame';

/**
 * Collection of all games for a customer
 * @export
 * @interface AllGames
 */
export interface AllGames {
    /**
     * 
     * @type {Array<FastPlayGameResponse>}
     * @memberof AllGames
     */
    fastPlayGames: Array<FastPlayGameResponse>;
    /**
     * 
     * @type {Array<RapidGame>}
     * @memberof AllGames
     */
    rapidGames: Array<RapidGame>;
    /**
     * 
     * @type {Array<InstantGame>}
     * @memberof AllGames
     */
    instantGames: Array<InstantGame>;
    /**
     * 
     * @type {Array<DrawGame>}
     * @memberof AllGames
     */
    drawGames: Array<DrawGame>;
}

/**
 * Check if a given object implements the AllGames interface.
 */
export function instanceOfAllGames(value: object): value is AllGames {
    if (!('fastPlayGames' in value) || value['fastPlayGames'] === undefined) return false;
    if (!('rapidGames' in value) || value['rapidGames'] === undefined) return false;
    if (!('instantGames' in value) || value['instantGames'] === undefined) return false;
    if (!('drawGames' in value) || value['drawGames'] === undefined) return false;
    return true;
}

export function AllGamesFromJSON(json: any): AllGames {
    return AllGamesFromJSONTyped(json, false);
}

export function AllGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllGames {
    if (json == null) {
        return json;
    }
    return {
        
        'fastPlayGames': ((json['fastPlayGames'] as Array<any>).map(FastPlayGameResponseFromJSON)),
        'rapidGames': ((json['rapidGames'] as Array<any>).map(RapidGameFromJSON)),
        'instantGames': ((json['instantGames'] as Array<any>).map(InstantGameFromJSON)),
        'drawGames': ((json['drawGames'] as Array<any>).map(DrawGameFromJSON)),
    };
}

export function AllGamesToJSON(value?: AllGames | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fastPlayGames': ((value['fastPlayGames'] as Array<any>).map(FastPlayGameResponseToJSON)),
        'rapidGames': ((value['rapidGames'] as Array<any>).map(RapidGameToJSON)),
        'instantGames': ((value['instantGames'] as Array<any>).map(InstantGameToJSON)),
        'drawGames': ((value['drawGames'] as Array<any>).map(DrawGameToJSON)),
    };
}

